import { alpha } from "@mui/material/styles";
// SETUP COLORS
const GREY = {
    0: "#FFFFFF",
    100: "#F9FAFB",
    200: "#F4F6F8",
    300: "#DFE3E8",
    400: "#C4CDD5",
    500: "#919EAB",
    600: "#637381",
    700: "#454F5B",
    800: "#212B36",
    900: "#161C24",
};
const PRIMARY = {
    lighter: "#CBF3FF",
    light: "#00B6ED",
    main: "#3192D0",
    dark: "#0B51A1",
    darker: "#00244D",
    contrastText: GREY[0],
    // Numbered shades
    10: "#EFF9FF",
    20: "#BBD8EB",
    30: "#77C0EE",
    40: "#3192D0",
    50: "#2585C3",
    60: "#2476A9",
    70: "#1B6EA3",
    80: "#12547E",
    90: "#103F5D",
    100: "#072132",
};
const SECONDARY = {
    lighter: "#9B9B9A",
    light: "#919EAB",
    main: "#00B6ED",
    dark: "#3D3D3C",
    darker: "#232322",
    contrastText: GREY[0],
    // Numbered shades (cyan/teal based on design system)
    10: "#EAFAFE",
    20: "#BEF0FF",
    30: "#57D3F8",
    40: "#00B6ED",
    50: "#009AC9",
    60: "#037496",
    70: "#02607D",
    80: "#03495E",
    90: "#01303F",
    100: "#011015",
};
const TERTIARY = {
    lighter: "#226EC3",
    light: "#1255A1",
    main: "#00244D",
    dark: "#00244D",
    darker: "#000C1A",
    contrastText: GREY[0],
    // Numbered shades
    10: "#226EC3",
    20: "#1255A1",
    30: "#063C79",
    40: "#00244D",
    50: "#000C1A",
};
const INFO = {
    lighter: "#CAFDF5",
    light: "#61F3F3",
    main: "#00B8D9",
    dark: "#006C9C",
    darker: "#003768",
    contrastText: GREY[0],
};
const SUCCESS = {
    lighter: "#E5FFC7",
    light: "#A1D360",
    main: "#76B82A",
    dark: "#4D850C",
    darker: "#315805",
    contrastText: GREY[0],
};
const WARNING = {
    lighter: "#FFF5CC",
    light: "#FFD666",
    main: "#FFAB00",
    dark: "#DAB607",
    darker: "#7A4100",
    contrastText: GREY[800],
};
const ERROR = {
    lighter: "#FFE9D5",
    light: "#FFAC82",
    main: "#FF5630",
    dark: "#B71D18",
    darker: "#7A0916",
    contrastText: "#FFFFFF",
};
const COMMON = {
    common: {
        black: "#000000",
        white: "#FFFFFF",
    },
    primary: PRIMARY,
    secondary: SECONDARY,
    tertiary: TERTIARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    divider: alpha(GREY[500], 0.2),
    action: {
        hover: alpha(GREY[500], 0.08),
        selected: alpha(GREY[500], 0.16),
        disabled: alpha(GREY[500], 0.8),
        disabledBackground: alpha(GREY[500], 0.24),
        focus: alpha(GREY[500], 0.24),
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
export function palette(mode) {
    const light = Object.assign(Object.assign({}, COMMON), { mode: "light", text: {
            primary: GREY[800],
            secondary: GREY[600],
            disabled: GREY[500],
            tertiary: GREY[600],
            info: INFO.main,
            success: SUCCESS.main,
        }, background: {
            paper: "#FFFFFF",
            default: "#FFFFFF",
            neutral: GREY[200],
        }, action: Object.assign(Object.assign({}, COMMON.action), { active: GREY[600] }) });
    const dark = Object.assign(Object.assign({}, COMMON), { mode: "dark", text: {
            primary: GREY[0],
            secondary: GREY[500],
            disabled: GREY[600],
        }, background: {
            paper: GREY[800],
            default: GREY[900],
            neutral: alpha(GREY[500], 0.12),
        }, action: Object.assign(Object.assign({}, COMMON.action), { active: GREY[500] }) });
    return mode === "light" ? light : dark;
}
